<div class="cas-flex-column-limit push-up-2">
    <form [formGroup]="editDetail" *ngIf="!isLoading && cbiOptionsGrouped.length > 0 else loadingView">
        <ng-container *ngIf="!done else doneView">
            <ng-container  *ngIf="mode === 'edit'">
                <div class="cas-form-block-title">{{_detailData?.year}}</div>
            </ng-container>
            <acabim-form-block labelWidth="9" [labelAlign]="'right'" [colonize]="true">
                <acabim-form-input-wrapper>
                    <acabim-form-input-label [required]="true">Amount</acabim-form-input-label>
                    <acabim-form-input-content [shortField]="true">
                        <div>
                            <input type="number" formControlName="amount"/>
                            <span class="cas-form-units">$</span>
                        </div>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
    <!--            <acabim-form-input-wrapper>-->
    <!--                <acabim-form-input-label>CBI class</acabim-form-input-label>-->
    <!--                <acabim-form-input-content [mediumField]="true">-->
    <!--                    <p-dropdown-->
    <!--                        formControlName="cbiClass"-->
    <!--                        [options]="cbiOptionsGrouped"-->
    <!--                        [group]="true"-->
    <!--                        [filter]="true"-->
    <!--                        placeholder="Select CBI class"></p-dropdown>-->
    <!--                </acabim-form-input-content>-->
    <!--            </acabim-form-input-wrapper>-->
                <acabim-form-input-wrapper *ngIf="mode !== 'edit'">
                    <acabim-form-input-label [required]="true">Year</acabim-form-input-label>
                    <acabim-form-input-content [mediumField]="true">
                        <p-dropdown
                            [filter]="true"
                            formControlName="year"
                            [options]="yearOptions"
                            placeholder="Select Year"></p-dropdown>
                    </acabim-form-input-content>
                </acabim-form-input-wrapper>
            </acabim-form-block>
            <div class="cas-action-buttons cas-action-buttons-bottom">
                <button (click)="close()">Cancel</button>
                <button (click)="delete()" *ngIf="_detailData">Delete</button>
                <button (click)="addBudget()" class="cas-button-action cas-button-right">SAVE</button>
            </div>
        </ng-container>
    </form>
</div>

<p-toast position="center" autoZIndex></p-toast>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"
                 acceptButtonStyleClass="cas-button-action"></p-confirmDialog>

<ng-template #doneView>
    <ng-container *ngIf="done">
        <div class="cas-info">
            <h4>Done!</h4>
            <p *ngIf="mode === 'add'">Successfully added budget to {{ltmItem?.maintenance_type_name}}.</p>
            <p *ngIf="mode === 'edit'">Successfully updated budget for {{ltmItem?.maintenance_type_name}}.</p>
            <button class="cas-button-action" (click)="completedSubmission()">Close</button>
        </div>
    </ng-container>
</ng-template>
